import {CreaturesNavPanel} from "@/scenes.ui/creatures-nav-panel";
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import CreaturePanel from "@/scenes.ui/creature-panel";
import Image = Phaser.GameObjects.Image;
import {Keys} from "@/constants/key";
import {Player} from "@/store/player/types";
import {CreatureUtils} from "@/utils/creature-utils";
import PlayerStore from "@/store/player";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export default class UnlimitedCreaturesPanel extends AbstractNavPanel implements CreaturesNavPanel {

    private creaturePanelById!: Map<number, CreaturePanel>;
    private creatures!: Creature[];
    private selectCallback!: (creature: Creature) => unknown;

    private selectionTop: Image | undefined;
    private selectionBottom: Image | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, selectCallback: (creature: Creature) => unknown,
                creatures: Creature[], selectedCreature: Creature) {
        super(scene, canvas, x, y, creatures, 6);
        this.x = x * CU.S;
        this.y = y * CU.S + 100;
        this.selectCallback = selectCallback;
        this.creatures = creatures;
        let c = selectedCreature;
        let cp = this.creaturePanelById.get(c.id);
        let cpX = 0;
        if (cp) {
            cpX = cp!.x;
        }

        this.selectionTop = SpriteUtils.addImage(this.scene, cpX / CU.S, -24, Keys.ATLAS_UI, Keys.UI_ARROW_UP).setInteractive();
        this.selectionBottom = SpriteUtils.addImage(this.scene, cpX / CU.S, 95, Keys.ATLAS_UI, Keys.UI_ARROW_DOWN).setInteractive();

        this.add([this.selectionTop, this.selectionBottom]);
    }

    protected makePanel(x: number, element: any) {
        let c: Creature = element;

        if (!this.creaturePanelById) {
            this.creaturePanelById = new Map<number, CreaturePanel>();
        }

        let creaturePanel = new CreaturePanel(this.scene!, x, 30, c, () => undefined, true);
        creaturePanel.setHealthVisible();
        creaturePanel.setDepth(1000);
        SpriteUtils.scale(creaturePanel, 0.7 / CU.S);

        creaturePanel.setCallback(() => {
            if (this.selectCallback != null) {
                this.playSelectSound();
                this.selectCallback(creaturePanel.getCreature());
            }
            this.doSelect(c);
        });

        this.creaturePanelById.set(c.id, creaturePanel)
        return creaturePanel;
    }

    public updateCreaturePanel(creatures: Creature[]): void {
        creatures.forEach(c => {
            let cp = this.creaturePanelById.get(c.id);
            if (cp && cp.active) {
                cp.setPanelCombative(c.combative);
            }
        });
    }

    protected onLeftPressed() {
        this.selectionTop!.alpha = 0;
        this.selectionBottom!.alpha = 0;
    }

    protected onRightPressed() {
        this.selectionTop!.alpha = 0;
        this.selectionBottom!.alpha = 0;
    }

    refreshSkills(): void {
        const self = this;
        const player: Player = PlayerStore.getPlayer();

        player.creatures.forEach(c => {
            let cp: CreaturePanel | undefined = self.creaturePanelById.get(c.id);
            if (cp) {
                cp.setSkills(c.skills);
                cp.setHealth(CreatureUtils.getUnitHealth(c));
            }
        });
    }

    public select(creatureIndex: number) {
        let creature: Creature = this.creatures[creatureIndex];
        this.doSelect(creature);
    }

    public doSelect(creature: Creature) {
        this.selectionTop!.alpha = 1;
        this.selectionBottom!.alpha = 1;

        while(!this.creaturePanelById.get(creature.id) || !this.creaturePanelById.get(creature.id)!.visible ) {
            this.shiftRight();
        }
        this.scene.tweens.add({
            targets: this.selectionTop,
            duration: 500,
            props: {
                x: { value: this.creaturePanelById.get(creature.id)!.x, ease: 'Quint.easeOut'}
            },
        });
        this.scene.tweens.add({
            targets: this.selectionBottom,
            duration: 500,
            props: {
                x: { value: this.creaturePanelById.get(creature.id)!.x, ease: 'Quint.easeOut'}
            },
        });

        this.selectCallback!(creature);
    }

    getActive(): boolean {
        return this.active;
    }

    getGameObject(): Phaser.GameObjects.GameObject {
        return this;
    }

    protected getButtonX(): number {
        return 250;
    }

    protected getButtonY(): number {
        return 30;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        if (creaturesAmount <= 3) {
            return 110;
        } else if (creaturesAmount <= 5) {
            return 90;
        }
        return 75;
    }
}
